import React from 'react';

const Dot = ({ color, onOpen, style = {} }) => (
  <div
    style={{
      width: 20,
      height: 20,
      border: `1px solid ${
        [
          '#fff',
          '#ffffff',
          '#FFF',
          '#FFFFFF',
          '',
          // 'transparent',
          undefined,
          null,
        ].includes(color)
          ? '#ff0063'
          : color
      }`,
      borderRadius: '50%',
      background: color,
      cursor: 'pointer',
      ...style,
    }}
    onClick={onOpen}
  />
);

export default Dot;
